let timings = {} as {[name: string]: number};

let ext = {} as {[name: string]: number};

export function startTiming(name: string) {
    timings[name] = Date.now();
};
export function endTiming(name: string) {
    pushTiming(name, Date.now() - timings[name]);
};
function pushTiming(name: string, timing: number) {
    const id = 'lh-' + name;
    ext[id] = timing;
    delete timings[id];
    waitBBForReport();
};

export function pointTiming(name: string) {
    if (window.performance && performance.timing && performance.timing.navigationStart) {
        pushTiming(name, Date.now() - performance.timing.navigationStart);
    }
}

let reportStart = false;
let count = 0;

function cleanup() {
    reportStart = false;
    count = 0;
    ext = {};
    timings = {};
};

document.addEventListener('lighthubbeforenavigation', () => {
    cleanup();
});

document.addEventListener('lighthubbeforeback', () => {
    cleanup();
});

function waitBBForReport() {
    if (reportStart) {
        return;
    }
    reportStart = true;

    const timer = setInterval(report, 500);
    count ++;

    function report() {
        if (count > 50) {
            clearInterval(timer);
            return;
        }
        // @ts-ignore
        let bbReady = window.__BB as boolean;
        if (location.href.indexOf('wh_weex=true') !== -1) {
            // wait redfox
            // @ts-ignore
            bbReady = bbReady && window.__BB.extendParams && window.__BB.extendParams.tech;
        }
        // @ts-ignore
        if (bbReady && window.__BB.exposed && window.__BB.extendParams) {
            // @ts-ignore
            window.__BB.extendParams = window.__BB.extendParams || {};
            if (ext) {
                // @ts-ignore
                Object.assign(window.__BB.extendParams, ext);
                clearInterval(timer);
            }
        }
    }
}